import React, { useState, useEffect } from 'react'
import Header from '../Components/Header';
import { Link } from "react-router-dom";
import axios from "axios";

const Maincategory = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedcategoryId, setSelectedCategoryId] = useState(null);
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


  const openDeleteModal = (category_id) => {
    setSelectedCategoryId(category_id)
    setShowModal(true);
  }

  const closeModal = () => {
    setSelectedCategoryId(null);
    setShowModal(false);
  };
  useEffect(() => {
    setLoading(true); // Set loading to true before fetching data
    axios
      .post(`${API_BASE_URL}category_list.php`)
      .then((response) => {
        if (response.data.head.code === 200) {
          // Sort categories by rank after fetching data
          const sortedCategories = response.data.body.sort((a, b) => a.rank - b.rank);
          setCategories(sortedCategories); // Store sorted categories in state
        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
      })
      .finally(() => {
        setLoading(false); // Set loading to false after API call
      });
  }, []);






  // Handle change in rank or active state
  const handleChange = (category_id, field, value) => {
    setCategories(categories.map(category =>
      category.category_id === category_id
        ? { ...category, [field]: value }
        : category
    ));
  };

  const handleDelete = async () => {
    if (!selectedcategoryId) return;

    try {
      const response = await axios.post(`${API_BASE_URL}category_list_delete.php`, {
        category_id: selectedcategoryId,
      });

      if (response.data.head.code === 200) {
        alert('Category Deleted Successfully')
        closeModal();
        window.location.reload();

      } else {
        alert(response.data.head?.msg || "Failed to delete category");
      }

    }
    catch (error) {
      console.error("Error Deleting Category", error)
    }

  };

  const handleUpdate = async(category_id,non_discount) => {
  try{
    const response = await axios.post(`${API_BASE_URL}category_list_update.php`,{
      category_id,
      non_discount,
    })
    if(response.data.head.code === 200){
      setCategories((prevCategories) =>
        prevCategories.map((category) =>
          category.category_id === category_id
            ? { ...category,  } 
            : category
        )
      );
      setUpdateSuccess(true); // Set state for success
    }else{
      console.error('Error updating category:', response.data.head.msg);
    }
  }catch(error){
    console.error('Error updating category:', error);
  }
}

 useEffect(() => {
    if (updateSuccess) {
      alert("Category Updated Successfully");
      setUpdateSuccess(false);
      window.location.href = window.location.href;
    }
  }, [updateSuccess]);

  return (
    <>
      <Header />
      <div class="page-wrapper compact-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
          <div className="page-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-table">
                    <div className="card-body">
                      <div className="title-header option-title d-sm-flex d-block">
                        <h5>List of Category</h5>
                        <div className="right-options">
                          <ul>
                            <li>
                              <Link className="btn btn-solid" to="/addmaincategory">
                                Add Category
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div>
                        <form>
                          {loading ? (
                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                              <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="table-responsive">
                                <table className="table all-package theme-table table-product">
                                  <thead>
                                    <tr>
                                      <th>S.No.</th>
                                      <th>Category</th>
                                      {/* <th style={{ textAlign: 'center' }}>Stock</th>
                  <th style={{ textAlign: 'center' }}>Rank</th>
                  <th style={{ textAlign: 'center' }}>Active</th>
                  <th style={{ textAlign: 'center' }}>Sub Category</th> */}
                                      <th style={{ textAlign: "center" }}>Non-Discount</th>
                                      <th style={{ textAlign: 'center' }}>Action</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {categories.length > 0 ? (
                                      categories.map((category, index) => (
                                        <tr key={category.category_id}>
                                          <td>{index + 1}</td>
                                          <td>{category.category_name}</td>
                                          {/* <td style={{ textAlign: 'center' }}>
                        <ul>
                          <li>
                            <Link to="/stock">
                              <i className="ri-list-check-2 ri-2x"></i>
                            </Link>
                          </li>
                        </ul>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <input
                          className="checkbox_animated check-it"
                          type="text"
                          size="4"
                          name={`rank_${category.category_id}`}
                          value={category.rank}
                          onChange={(e) => handleChange(category.category_id, 'rank', e.target.value)}
                        />
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <input
                          className="checkbox_animated check-it"
                          type="checkbox"
                          name={`act_${category.category_id}`}
                          value="1"
                          checked={category.active === '1'}
                          onChange={(e) => handleChange(category.category_id, 'active', e.target.checked ? '1' : '0')}
                        />
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <Link to={`/subcategory/${category.category_id}`}>
                          <i className="ri-list-unordered ri-2x"></i>
                        </Link>
                      </td> */}
                                          <td style={{ textAlign: "center" }}>
                                            <input
                                              className="checkbox_animated check-it"
                                              type="checkbox"
                                              name={`non_discount${category.category_id}`}
                                              value="1"
                                              checked={category.non_discount === '1'}
                                              onChange={(e) => handleChange(category.category_id, 'non_discount', e.target.checked ? '1' : '0')}
                                            />
                                          </td>
                                          <td style={{ textAlign: 'center' }}>
                                            <ul>
                                              <li>
                                                <Link to={`/editmaincategory/${category.category_id}`}>
                                                  <i className="ri-pencil-line"></i>
                                                </Link>
                                              </li>
                                              <li>
                                                <a href="#" onClick={(e) => { e.preventDefault(); openDeleteModal(category.category_id); }}>
                                                  <i className="ri-delete-bin-line"></i>
                                                </a>
                                              </li>
                                            </ul>
                                          </td>
                                        </tr>
                                      ))
                                    ) : (
                                      <tr>
                                        <td colSpan="7" style={{ textAlign: 'center' }}>
                                          No categories found.
                                        </td>
                                      </tr>
                                    )}
                                  </tbody>
                                </table>
                              </div>
                             <div class="card-footer border-0 pb-0 d-flex justify-content-end">
                             
                              <button class="btn btn-primary me-3" type="button"
                                onClick={() => {
                                  categories.forEach((Category) => {
                                    handleUpdate(Category.category_id,  Category.non_discount,);
                                  });
                                }}
                              >Update</button>
                            </div>
                            </>
                          )}
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      {showModal && (
        <div className="modal fade show" style={{ display: "block" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <h5>Confirm Delete</h5>
                <p>Are you sure you want to delete this category?</p>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                  No
                </button>
                <button type="button" className="btn btn-danger" onClick={handleDelete}>
                  Yes, Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  )
}

export default Maincategory